import React, { useEffect, useRef } from 'react';
import { InputCompo } from '../../../Components/InputCompo/InputCompo';
import { useLocation } from 'react-router-dom';

const TrustAndTransparencyAdv = ({ values, setFieldValue, setAdvPostData }) => {



  const checkboxList = [
    { name: 'platinum', label: 'Platinum' },
    { name: 'gold', label: 'Gold' },
    { name: 'silver', label: 'Silver' },
    { name: 'Bronze under review for higher certification', label: 'Bronze +' },
    { name: 'bronze', label: 'Bronze' },
    { name: 'basic level', label: 'Engage' },
    { name: 'entry level', label: 'Discover' },
  ];





  const searchParams = new URLSearchParams(window.location.search);
  const advancedSearchUrlQuery = searchParams.get('AdvancedSearch');

  useEffect(() => {
    if (advancedSearchUrlQuery) {
      try {
        // Decode and parse the query string
        const decodedQuery = decodeURIComponent(advancedSearchUrlQuery);
        const parsedData = JSON.parse(decodedQuery); // Assuming it's a JSON string
        // reCallApi(parsedData);
        setAdvPostData(parsedData);
      } catch (error) {
        console.error("Error parsing search query:", error);
      }
    }
  }, [advancedSearchUrlQuery]);

  // Ensure `indicator` is extracted from the parsed query

  return (
    <>

      {/* Trust and Transparency Level Section */}
      <div className="p-[10px] rounded-xl mt-[20px] bg-[white]">
        <div className="w-[100%]">
          {checkboxList.map((ele) => {
            return (
              <label
                className="flex mt-[16px] items-center space-x-2"
                key={ele?.label}
              >
                <InputCompo
                  onChange={() => {
                    setFieldValue(ele.name, !values[ele.name]);
                  }
                  }
                  checked={!!values[ele.name]} // Ensure checkbox state is in sync
                  name={ele.name}
                  className="bg-[#004878] text-white w-[20px] h-[20px]"
                  type="checkbox"
                />
                <span className="text-black">{ele.label}</span>
              </label>
            );
          })}
        </div>
      </div>



    </>
  )
}

export default TrustAndTransparencyAdv